import { render, staticRenderFns } from "./PreparationsOverview.vue?vue&type=template&id=cbca9d4c&"
import script from "./PreparationsOverview.vue?vue&type=script&lang=ts&"
export * from "./PreparationsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports